import React from "react";
import { PAGE_LAYOUT } from "../layout/pageLayout";
import { usePermissions } from "../hooks/usePermissions";
import { CAPABILITY, DATA_SCOPE, VISIBILITY } from "../helpers/permissions";
import { CrewPilotModuleShell } from "./CrewPilotModuleShell";
import { useIsDesktopViewport } from "../hooks/useIsDesktopViewport";
import { PayrollHomeDesktop } from "./payroll/PayrollDesktop";

function payrollScopeLabel(scope) {
  if (scope === DATA_SCOPE.ORGANIZATION) {
    return "Organization payroll";
  }
  if (scope === DATA_SCOPE.TEAM) {
    return "Team payroll";
  }
  return "Your payroll entries";
}

export function PayrollHomeScreen({
  onBack,
  onOpenQueue,
}) {
  const isDesktop = useIsDesktopViewport();
  const { scope, can, visibility } = usePermissions();
  const payrollScope = scope(CAPABILITY.PAYROLL_QUEUE);

  if (isDesktop) {
    return (
      <PayrollHomeDesktop
        onBack={onBack}
        scopeLabel={payrollScopeLabel(payrollScope)}
        isSelfScope={payrollScope === DATA_SCOPE.SELF}
        canMarkPaid={
          can(CAPABILITY.PAYROLL_MARK_PAID) &&
          visibility(CAPABILITY.PAYROLL_MARK_PAID) === VISIBILITY.EDIT
        }
        onOpenQueue={onOpenQueue}
      />
    );
  }

  return (
    <CrewPilotModuleShell
      title="Payroll"
      subtitle={payrollScopeLabel(payrollScope)}
      onBack={onBack}
      layout={PAGE_LAYOUT.COMMAND}
      primary
    >
      <div className="cp-card-grid">
        <div
          className="kpi-card cp-card-grid__card"
          role="button"
          tabIndex={0}
          onClick={onOpenQueue}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onOpenQueue?.();
            }
          }}
          style={{
            cursor: "pointer",
            padding: "18px 16px",
            margin: "0 20px",
          }}
        >
          <h3 style={{ color: "var(--nx-text)", margin: "0 0 8px" }}>
            Payroll Queue
          </h3>

          <p style={{ color: "var(--nx-text-muted)", margin: 0 }}>
            {payrollScope === DATA_SCOPE.SELF
              ? "Review your payroll entries and pay period status."
              : "Process payroll entries, mark paid/unpaid, and manage payroll status."}
          </p>

          <div
            style={{
              marginTop: "16px",
              color: "var(--nx-gold-ink, #8a6d23)",
              fontWeight: 700,
            }}
          >
            Open Queue →
          </div>
        </div>
      </div>
    </CrewPilotModuleShell>
  );
}
